import { Page } from "../../../../components/Page";
import { useApp } from "../../../../helpers/app-context";
import { getUser } from "../../../../helpers/utils";
import { Calendar } from "../calendar/components/Calendar";
import { CalendarView } from "./components/CalendarView";
import { DetailedRevenueSummary } from "./components/DetailedRevenueSummary";
import { Notification } from "./components/Notification";
import { PickupReportChart } from "./components/PickupReport/PickupReportChart";
import { RevParSummary } from "./components/RevParSummary";
import { RevenueChart } from "./components/RevenueSummary/RevenueChart";
import { SummaryChart } from "./components/SummaryChart";
import { TrendsLineChart } from "./components/TrendsLineChart/TrendsLineChart";

export function Analytics({ user }) {
  const { isChatBotOpen } = useApp() as { isChatBotOpen: boolean };
  return (
    <div
      className={`py-5 flex-1 ${
        isChatBotOpen ? "w-[calc(100vw-350px)]" : ""
      } 1xl:w-[unset]`}
    >
      <div className="flex flex-col 1xl:flex-row 1xl:items-center justify-between gap-0 flex-wrap">
        <div className="flex items-center justify-between 1xl:justify-end gap-3 flex-1 xl:flex-[2.02]">
          <RevParSummary user={user} />
        </div>
      </div>
      <div className="hidden 1xl:block mt-4">
        <div className="pb-1 flex items-stretch gap-4  3xl:gap-6 tall3XL:h-full">
          <div className="flex flex-col gap-4  3xl:gap-6 flex-[3]">
            <div
              className={`flex-[3] 3xl:flex-[4]  max-h-[310px] tall3:max-h-[360px] tall3XL:max-h-[410px] ${
                !isChatBotOpen ? "tall3:flex-[4]" : ""
              }`}
            >
              <RevenueChart user={user} />
            </div>
            <div className="flex-[4]  max-h-[401px] tall3XL:max-h-[501px]">
              <DetailedRevenueSummary user={user} />
            </div>
          </div>
          <div className="flex flex-col gap-4  3xl:gap-6 flex-1">
            <div
              className={`flex-[3] 3xl:flex-[4]   max-h-[310px] tall3:max-h-[360px] tall3XL:max-h-[410px] ${
                !isChatBotOpen ? "tall3:flex-[4]" : ""
              }`}
            >
              <TrendsLineChart user={user} />
            </div>
            <div className="flex-[4]  max-h-[401px] tall3XL:max-h-[501px]">
              <PickupReportChart user={user} />
            </div>
          </div>
          <div className="flex flex-col gap-4  3xl:gap-6 flex-1">
            <div
              className={`flex-[3] 3xl:flex-[4]  max-h-[310px] tall3:max-h-[360px] tall3XL:max-h-[410px] ${
                !isChatBotOpen ? "tall3:flex-[4]" : ""
              }`}
            >
              <SummaryChart user={user} />
            </div>
            <div className="flex-[4]  max-h-[401px] tall3XL:max-h-[501px]">
              <CalendarView user={user} />
            </div>
          </div>
        </div>
      </div>
      <div
        className={
          "hidden md:hidden 1xl:hidden h-[calc(100vh-150px)] overflow-auto lg:flex flex-col gap-4"
        }
      >
        <div className="pb-1 flex items-stretch mt-4 gap-4">
          <div className="flex-1">
            <RevenueChart user={user} />
          </div>
          <TrendsLineChart user={user} />
        </div>
        <div className="pb-1 flex items-stretch mt-4 gap-4">
          <div className="flex-1">
            <DetailedRevenueSummary user={user} />
          </div>
        </div>
        <div className="pb-1 flex items-stretch mt-4 gap-4">
          <div className="flex-1">
            <PickupReportChart user={user} />
          </div>
          <div className="flex-1">
            <SummaryChart user={user} />
          </div>
          <div className="flex-1">
            <CalendarView user={user} />
          </div>
        </div>
      </div>
      <div className={"lg:hidden flex flex-col gap-4"}>
        <div className="flex-1 mt-4">
          <RevenueChart user={user} />
        </div>
        <div className="pb-1 flex md:flex-row flex-col items-stretch gap-4">
          <div className="flex-1">
            <TrendsLineChart user={user} />
          </div>
          <div className="flex-1">
            <SummaryChart user={user} />
          </div>
        </div>
        <div className="flex-1">
          <DetailedRevenueSummary user={user} />
        </div>
        <div className="pb-1 flex md:flex-row flex-col items-stretch gap-4">
          <div className="flex-1">
            <PickupReportChart user={user} />
          </div>
          <div className="flex-1">
            <CalendarView user={user} />
          </div>
        </div>
      </div>
    </div>
  );
}
